import { isProd } from './getConfigs';
import mitt from 'mitt';

const authBaseUrl = isProd ? 'https://auth-dist.awscconsumerinfo.autotrader.com/prod/v0' : 'https://auth-dist.awscconsumerinfonp.autotrader.com/nonprod/v0';

export const authUtilsUrl = `${authBaseUrl}/auth-utility.esm.js`;
export const authComponentsUrl = `${authBaseUrl}/cai-authentication-web-components.esm.js`;

export const importAuthUtils = async () => {
  globalThis.caiEventBus ||= mitt();
  return import(authUtilsUrl).then(authModules => {
    if (authModules) {
      globalThis.PSX_AUTH = {
        isUserSignedIn: authModules.isUserSignedIn,
        getCognitoIdToken: authModules.getCognitoIdToken,
        getCognitoAccessToken: authModules.getCognitoAccessToken,
        showAuthModal: authModules.showAuthModal,
        signOut: authModules.signOut,
        getConsumerId: authModules.getConsumerId,
      };
    }
  });
};

export const authComponentDefined = async () => {
  return customElements.whenDefined('cai-authentication');
};
